module.exports = __webpack_public_path__ + "media/images/mosaico-pl-216faba4c0d3c65254729bf68ca995cd.jpg";